<script setup lang="ts">
import { DfSection } from '~/src/shared/ui/df-design/vue';
import { ProductCard, type ProductInfo } from '~/src/entities/product';

const props = defineProps<{ products: ProductInfo[] }>();
const billing = ref(false);
</script>

<template>
  <DfSection>
    <div v-if="props.products" class="pricing-table">
      <el-switch v-model="billing" active-text="Annual Billing" inactive-text="Monthly Billing" />
      <div class="pricing-table__cards">
        <ProductCard v-for="(product, index) in props.products" :key="index" :product-info="product" :index="index" :is-annual="billing" />
      </div>
    </div>
  </DfSection>
</template>

<style lang="scss" scoped>
.pricing-table {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  &__cards {
    padding: 0px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}
@media (min-width: 768px) {
  .pricing-table__cards {
    flex-direction: row;
    align-items: center;
  }
}
</style>
